import React, { useMemo } from "react"
import { useDispatch } from "react-redux"
import { chartInitialize, changeSymbol } from "redux/ducks/Chart"
import { indicatorChartInitialize } from "redux/ducks/IndicatorChart"
import uuid from "uuid"

interface props {
  symbolData?: object
  chartType: string
  id?: string
  data?: object
}

const useChartInitialize = (props: props) => {
  const { symbolData, id, chartType, data } = props
  const canvasId = useMemo(() => {
    return id || uuid()
  }, [])
  const dispatch = useDispatch()
  const _data = useMemo(() => {
    return data || {}
  }, [data])

  useMemo(async () => {
    dispatch(chartInitialize(canvasId, chartType, _data))
    if (!symbolData) return
    dispatch(changeSymbol(canvasId, symbolData))
  }, [canvasId])

  return canvasId
}

export const useIndicatorChartInitialize = (canvasId?: string) => {
  const dispatch = useDispatch()
  const _canvasId = useMemo(() => {
    return !canvasId ? uuid() : canvasId
  }, [])
  useMemo(async () => {
    dispatch(indicatorChartInitialize(_canvasId))
  }, [_canvasId])

  return _canvasId
}

export default useChartInitialize
